import type { OptionsDocument, QuoteDocument } from 'paintscout'
import { getPayments } from '@paintscout/util/builder'
import getDepositAmount from '@paintscout/util/util/getDepositAmount/getDepositAmount'

/** Sum of in-flight (processing, not-yet-paid) payments on the doc. */
export function getProcessingTotal(quote: QuoteDocument): number {
  const payments = getPayments({ quote })
  return payments
    .filter(
      (p) =>
        p.status === 'processing' &&
        !payments.some((other) => other.activityId === p.activityId && other.status === 'paid')
    )
    .reduce((sum, p) => sum + Math.abs(Number(p.amount)), 0)
}

/**
 * The amount the presentation Pay button should charge, computed from a freshly-fetched doc so a
 * payment that went processing after page load reduces (or zeroes) what the customer is asked for.
 * Deposit flow: an in-flight deposit lives on the child invoice and is advertised here only via
 * depositInfo, so any depositInfo means nothing further is payable from this button.
 */
export function getFreshPayAmount(args: { quote: QuoteDocument; options: OptionsDocument; deposit: boolean }): number {
  const { quote, options, deposit } = args
  const processingTotal = getProcessingTotal(quote)
  if (deposit) {
    if (quote.depositInfo) return 0
    return Math.max(0, getDepositAmount({ quote, options }) - processingTotal)
  }
  return Math.max(0, quote.totals.balance_due - processingTotal)
}
